module.exports = {
  SERVER: {
    url: process.env.REACT_APP_SERVER_URL || 'https://demo.api.greenhouses.app',
    port: process.env.PORT || 5001,
    apiPath: process.env.API_PATH || 'api/v1'
  }
};
